import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Drawer, IconButton, Typography } from "@mui/material"
import { FlatButton } from "src/framework/components/buttons/FlatButton"
import { useObservable } from "src/framework/store/storeUtil"
import { Projeto } from "../../types"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import { servicoInformationModalIsOpenedStore$ } from "src/store/vendas/projetos/store"
import { setServicoInformationModalStatus } from "src/store/vendas/projetos/actions"

interface ServicoInformationModalProps {
  formState: Projeto
}

const formatMoney = (valor: any) =>{
  return Formater.toString(valor, TypeRecords.CURRENCY)
}

function ServicoInformationModal({ formState }: ServicoInformationModalProps){
  const isOpened = useObservable(servicoInformationModalIsOpenedStore$)

  return (
    <Dialog
        open={isOpened || false}
        onClose={() => setServicoInformationModalStatus(false)}
      >
        <DialogTitle>Valor do serviço da revenda com PIS/COFINS</DialogTitle>

        <Box paddingBottom={2}>
          <Divider />
        </Box>

        <DialogContent
          style={{ minWidth: "300px" }}
        >
          <DialogContentText>
          <Typography variant='body2' color='textSecondary' align="left">
            Proposta comercial com serviço incluso! O valor total de serviço, incluindo PIS/COFINS, é de {formatMoney(formState.valor_servico_pis_cofins || 0)}.<br/>
            O valor líquido do serviço a ser recebido pela revenda, e que deverá ser utilizado para emissão da Nota Fiscal é de {formatMoney(formState.valor_servico || 0)}.
          </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <FlatButton
            onClick={() => setServicoInformationModalStatus(false)}
            color="primary"
            variant="contained"
            text={'Fechar'}
          ></FlatButton>
        </DialogActions>
      </Dialog>
  )
}

export { ServicoInformationModal }